import { Breadcrumb, Button, Col, Input, message, Row } from 'antd';
import React, { Component } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

const OutDatesBox = styled.p`
  margin-top: 5rem;
  height: 40rem;
  width: 100%;
  word-break: break-all;
  overflow-y: auto;
`;

interface State {
  inputDate: string;
  showOutDates: boolean;
}

interface Props {}
type AllProps = RouteComponentProps<Props>;

export class DateProcess extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      inputDate: '',
      showOutDates: false,
    };
  }
  onChangeDate(e: { target: { value: string } }) {
    this.setState({ inputDate: e.target.value });
  }
  onClean = () => {
    this.setState({ inputDate: '', showOutDates: false });
  };
  onOutputDatas = () => {
    if (this.state.inputDate === '') {
      message.info('输入框不能为空');
    } else {
      const inputDates: string = this.state.inputDate;
      const outDates: string = inputDates.replace(/\s/g, '|');
      this.setState({ inputDate: outDates, showOutDates: true });
    }
  };
  render() {
    const { TextArea } = Input;
    return (
      <div>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>数据整理</Breadcrumb.Item>
        </Breadcrumb>
        <TextArea
          placeholder="请输入......"
          autosize={{ minRows: 20 }}
          value={this.state.inputDate}
          onChange={e => this.onChangeDate(e)}
          style={{ marginBottom: 26 }}
        />
        <Row>
          <Col span={1} offset={21}>
            <Button type="primary" onClick={this.onClean}>
              清空
            </Button>
          </Col>
          <Col span={1} offset={1}>
            <Button type="primary" onClick={this.onOutputDatas}>
              输出
            </Button>
          </Col>
        </Row>

        {this.state.showOutDates ? <OutDatesBox>({this.state.inputDate})</OutDatesBox> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/tools/DateProcess.tsx